import { render, staticRenderFns } from "./RiskRatingSummary.vue?vue&type=template&id=26743d30&scoped=true"
import script from "./RiskRatingSummary.vue?vue&type=script&lang=js"
export * from "./RiskRatingSummary.vue?vue&type=script&lang=js"
import style0 from "./RiskRatingSummary.vue?vue&type=style&index=0&id=26743d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26743d30",
  null
  
)

export default component.exports